import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Scanner } from '@yudiel/react-qr-scanner';
import '../App.css';

const API_URL = process.env.REACT_APP_API_URL || '';

const ScannerPage = () => {
  const [feedback, setFeedback] = useState('idle'); // idle, success, invalid, already_used
  const [processing, setProcessing] = useState(false);
  const [attendeeName, setAttendeeName] = useState('');
  const [attendedTime, setAttendedTime] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem('staff_token')) {
      navigate('/staff');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('staff_token');
    navigate('/staff');
  };

  const handleScan = async (detectedCodes) => {
    if (processing || !detectedCodes || detectedCodes.length === 0) return;
    const rawValue = detectedCodes[0].rawValue;
    if (!rawValue) return;
    // Support both URL format (https://durden.fr/ticket/:id) and raw UUID
    const ticketId = rawValue.includes('/ticket/')
      ? rawValue.split('/ticket/')[1]
      : rawValue;

    setProcessing(true);
    setFeedback('idle');

    try {
      const token = localStorage.getItem('staff_token');
      const res = await fetch(`${API_URL}/api/validate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ ticketId }),
      });

      if (res.status === 401) {
        localStorage.removeItem('staff_token');
        navigate('/staff');
        return;
      }

      const data = await res.json();

      if (data.status === 'success') {
        setFeedback('success');
        setAttendeeName(`${data.firstName} ${data.lastName}`);
      } else if (data.status === 'already_used') {
        setFeedback('already_used');
        setAttendeeName(`${data.firstName} ${data.lastName}`);
        setAttendedTime(new Date(data.attendedAt).toLocaleTimeString());
      } else {
        setFeedback('invalid');
      }

      setTimeout(() => {
        setFeedback('idle');
        setProcessing(false);
      }, 3000);

    } catch (error) {
      console.error(error);
      setFeedback('invalid');
      setTimeout(() => {
        setFeedback('idle');
        setProcessing(false);
      }, 3000);
    }
  };

  const getFeedbackConfig = () => {
    switch (feedback) {
      case 'success':
        return { bgColor: 'bg-success', title: 'ACCÈS AUTORISÉ', message: `Bienvenue, ${attendeeName}` };
      case 'already_used':
        return { bgColor: 'bg-already-scanned', title: 'DÉJÀ SCANNÉ', message: `${attendeeName} a déjà été scanné à ${attendedTime}` };
      case 'invalid':
        return { bgColor: 'bg-invalid', title: 'BILLET INVALIDE', message: 'Billet non reconnu dans la base' };
      default:
        return { bgColor: 'bg-idle', title: 'PRÊT À SCANNER', message: 'Placez le QR Code dans le cadre' };
    }
  };

  const config = getFeedbackConfig();

  return (
    <div className={`app-container ${config.bgColor}`} style={{ transition: 'background-color 0.5s' }}>
      <div className="top-bar">
        <h1 className="top-bar-title">Scanner Staff</h1>
        <button className="logout-btn" onClick={handleLogout}>
          Déconnexion
        </button>
      </div>

      <div className="scanner-container">
        <div className="scanner-viewport">
          {feedback === 'idle' ? (
            <Scanner
              onScan={handleScan}
              formats={['qr_code']}
              components={{ finder: false }}
              styles={{ container: { width: '100%', height: '100%' } }}
            />
          ) : (
            <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.8)' }}></div>
          )}

          {feedback === 'idle' && <div className="scanner-line"></div>}
        </div>

        <div className="feedback-msg">
          <h2>{config.title}</h2>
          <p>{config.message}</p>
        </div>
      </div>
    </div>
  );
};

export default ScannerPage;
